import React from "react";
import "../../styles/global-hero.css";

const Hero = () => {
    return (
        <div className="global-hero">
            <div className="container text-center">
                <h1>Student Council</h1>
                <p>Home &gt; Student Council</p>
            </div>
        </div>
    );
};

export default Hero;
